import React from "react";
import TableSelector from "../../../components/tables/TableSelector";
import spqr1 from "../../../components/tables/znw-1";
import spqr2 from "../../../components/tables/znw-2";
import spqr3 from "../../../components/tables/znw-3";
import spqr4 from "../../../components/tables/znw-4";
import spqr5 from "../../../components/tables/znw-5";
import spqr36 from "../../../components/tables/znw-36";

const data = [
  {
    les: "1",
    table: spqr1
  },
  {
    les: "2",
    table: spqr2
  },
  {
    les: "3",
    table: spqr3
  },
  {
    les: "4",
    table: spqr4
  },
  {
    les: "5",
    table: spqr5
  },
  {
    les: "36",
    table: spqr36
  }
];

export default () => (
  <TableSelector
    defaultChapter="36"
    data={data}
    title="Zelfstandig naamwoord"
  />
);



// WEBPACK FOOTER //
// ./src/pages/spqr/rijtjes/zelfstandig-naamwoord.js